<div *ngIf="!isCustomUiChange">
    <h5 mat-dialog-title style="padding:0.2vw; color:black; margin:0 !important">Create Role</h5>
    <mat-divider></mat-divider>
    <div mat-dialog-content style="height: 45vh;
width: 100vh;">
        <mat-card class="user-card" style="width: 93%;">
            <mat-card-content>
                <mat-form-field appearance="outline" class="formfield-half" style="width:50% !important">
                    <mat-label>Role ID</mat-label>
                    <input matInput placeholder="Name" [(ngModel)]="roleId" (focusin)="clearMessage()" maxlength="20">
                </mat-form-field>
                <mat-form-field appearance="outline" class="formfield-half" style="width:50% !important">
                    <mat-label>Role Name</mat-label>
                    <input matInput placeholder="Name" [(ngModel)]="roleName" (focusin)="clearMessage()" maxlength="50">
                </mat-form-field>
                <br>
                <mat-slide-toggle [(ngModel)]="roleActive">Active</mat-slide-toggle>
                <br>
                <br>
                <label style="color: red; font-size: 0.9vw">{{errorMessage}}</label>
            </mat-card-content>
            <mat-card-actions>
                <button mat-raised-button color="primary" (click)="saveRole();">SAVE</button>
                <button mat-raised-button color="primary" (click)="cancelRole();">CANCEL</button>
            </mat-card-actions>
        </mat-card>
    </div>
</div>

<!-- new CSS chages apply for FEMD and DOM1 -->
<div *ngIf="isCustomUiChange" class="role-create-container">
    <mat-card class="role-create-card">
        <mat-card-header class="role-card-header">
            <mat-card-title class="role-create-title">Create Role</mat-card-title>
            <button mat-icon-button class="role-create-close" (click)="cancelRole()">
                <mat-icon>close</mat-icon>
            </button>
        </mat-card-header>
        <mat-divider></mat-divider>
        <mat-card-content class="role-create-form">
            <mat-form-field appearance="outline" class="role-field-half">
                <mat-label>Role ID</mat-label>
                <input matInput [(ngModel)]="roleId" maxlength="20" placeholder="Role ID" (focusin)="clearMessage()">
            </mat-form-field>

            <mat-form-field appearance="outline" class="role-field-half">
                <mat-label>Role Name</mat-label>
                <input matInput [(ngModel)]="roleName" maxlength="50" placeholder="Role Name" (focusin)="clearMessage()">
            </mat-form-field>

            <mat-slide-toggle [(ngModel)]="roleActive">Active</mat-slide-toggle>
            <label class="role-error-msg">{{ errorMessage }}</label>
        </mat-card-content>

        <mat-card-actions class="role-create-actions">
            <button mat-raised-button color="primary" (click)="saveRole()">SAVE</button>
            <button mat-raised-button color="primary" (click)="cancelRole()">CANCEL</button>
        </mat-card-actions>
    </mat-card>
</div>